import { EnvironmentProviders, makeEnvironmentProviders } from '@angular/core';
import { ComponentInfoService } from './json-api/component-info.service';
import { ProvidersService } from './json-api/providers.service';
import { UserService } from './json-api/user.service';
import { AddressService } from './json-api/address.service';
import { IpensiiAuthConfig } from '@ipensii/shared/domain-shared';
import { AUTH_CONFIG, AuthService } from './auth.service';
import { LoggedInContextService } from './json-api/logged-in-context.service';
import { OnboardingRequestService } from './json-api/onboarding-request.service';
import { CacheService } from './cache.service';
import { HttpRequestService } from './http-request.service';
import { authHeaderInterceptor } from './http/auth-header.interceptor';
import { httpClientErrorInterceptor } from './http/http-client-error.interceptor';

export const httpClientInterceptors = [authHeaderInterceptor, httpClientErrorInterceptor];

export const provideDataAccessShared: () => EnvironmentProviders = () =>
  makeEnvironmentProviders([
    ComponentInfoService,
    ProvidersService,
    UserService,
    AddressService,
    LoggedInContextService,
    OnboardingRequestService,
    CacheService,
    HttpRequestService,
  ]);

export const provideAuth: ({ authConfig }: { authConfig: IpensiiAuthConfig }) => EnvironmentProviders = ({
  authConfig,
}) =>
  makeEnvironmentProviders([
    {
      provide: AUTH_CONFIG,
      useValue: authConfig,
    },
    AuthService,
  ]);
